import React, { FC } from 'react';
import { useOrchestratorState } from '@wix/gg-components/orchestrator';
import { useFlowContext } from 'context/FlowProvider';
import { LinearProgressBar, Text } from '@wix/design-system';
import styles from './Header.scss';

export const HeaderProgress: FC = () => {
  const { currentStep } = useOrchestratorState();
  const { steps } = useFlowContext();

  const filteredSteps = steps.filter((step) => step.params?.hideProgress !== true);
  const currentStepIndex = filteredSteps.findIndex((step) => step.id === currentStep?.id) + 1;

  return currentStep?.params?.hideProgress ? null : (
    <div className={styles.headerProgress}>
      <LinearProgressBar value={(currentStepIndex / filteredSteps.length) * 100} />
      <div className={styles.headerProgressText}>
        <Text size="small">
          {currentStepIndex} / {filteredSteps.length}
        </Text>
      </div>
    </div>
  );
};
